
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M3 19.5001C3 20.6047 3.89543 21.5001 5 21.5001H19.5C20.6046 21.5001 21.5 20.6047 21.5 19.5001V16.1001C21.5 14.9955 20.6046 14.1001 19.5 14.1001H5C3.89543 14.1001 3 14.9955 3 16.1001V19.5001ZM17.8049 15.955C18.8261 15.955 19.65 16.7838 19.65 17.8001C19.65 18.8213 18.8212 19.6452 17.8049 19.6452C16.7837 19.6452 15.9599 18.8164 15.9599 17.8001C15.9549 16.7789 16.7837 15.955 17.8049 15.955ZM8.55 15.9501H10.4V19.6501H8.55V15.9501ZM4.84013 15.9501H6.69013V19.6501H4.84013V15.9501Z"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M19.8108 3.80388C19.7173 3.33646 19.3069 3 18.8302 3H5.6698C5.19312 3 4.78271 3.33646 4.68922 3.80388L3.23922 11.0539C3.11546 11.6727 3.58876 12.25 4.2198 12.25H20.2802C20.9112 12.25 21.3845 11.6727 21.2608 11.0539L19.8108 3.80388Z"
      }
    }
  ]
})
    }
  